import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes, FaChevronDown } from 'react-icons/fa';

// ✅ Sub-menu untuk FUNGSIONARIS, disamakan dengan data di halaman Fungsionaris.js
const fungsionarisSubLinks = [
    { path: '/fungsionaris/phmj', name: 'PHMJ' },
    { path: '/fungsionaris/kontak-korsek', name: 'Koordinator Sektor' },
    { path: '/fungsionaris/pengurus-pelkat', name: 'Pengurus Pelkat' },
    { path: '/fungsionaris/presbiter', name: 'Presbiter' },
    { path: '/fungsionaris/komisi', name: 'Komisi-Komisi' },
];

// Struktur data navLinks, FUNGSIONARIS sekarang punya subLinks
const navLinks = [
    { path: '/', name: 'BERANDA' },
    { path: '/warta-jemaat', name: 'WARTA JEMAAT' },
    { path: '/tata-ibadah', name: 'TATA IBADAH' },
    { path: '/fungsionaris', name: 'FUNGSIONARIS', subLinks: fungsionarisSubLinks },
    { path: '/absensi-pelkat', name: 'ABSENSI PELKAT' },
    { path: '/formulir', name: 'FORMULIR' },
    { path: '/berita-duka', name: 'BERITA DUKA' },
    { path: '/sejarah', name: 'SEJARAH' },
];

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [openDesktopDropdown, setOpenDesktopDropdown] = useState(null); // ✅ path link yang dropdown-nya lagi kebuka (desktop)
    const [openMobileAccordion, setOpenMobileAccordion] = useState(null); // ✅ path link yang accordion-nya lagi kebuka (mobile)
    const location = useLocation();

    // ✅ Cek apakah link (atau salah satu sub-link-nya) sedang aktif, buat styling highlight
    const isLinkActive = (link) => {
        if (location.pathname === link.path) return true;
        if (link.subLinks) {
            return link.subLinks.some((sub) => location.pathname === sub.path);
        }
        return false;
    };

    return (
        <header className="bg-white sticky top-0 z-50 shadow-lg">
            <nav className="max-w-8xl mx-auto py-2 flex items-center justify-between relative px-2 sm:px-4 lg:px-10">

                {/* Logo/Nama Gereja */}
                <Link
                    to="/"
                    className="flex items-center space-x-3 md:space-x-4 lg:mr-8 flex-shrink-0"
                >
                    <img src="/images/gpib.png" alt="Logo GPIB" className="h-12 md:h-14 transition-transform duration-300 hover:scale-110" />
                    <h1 className="text-lg md:text-xl font-extrabold text-blue-900 tracking-wide transition-colors duration-300 hover:text-blue-600">
                        GPIB - KAKABA
                    </h1>
                </Link>

                {/* Tombol Hamburger/Menu Mobile */}
                <button
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                    className="lg:hidden text-gray-600 hover:text-blue-600 text-2xl focus:outline-none transition-colors"
                >
                    {isMenuOpen ? <FaTimes /> : <FaBars />}
                </button>

                {/* Navigasi Desktop */}
                <ul className="hidden lg:flex lg:items-center lg:space-x-6">
                    {navLinks.map((link) => {
                        const active = isLinkActive(link);
                        const hasSubLinks = Boolean(link.subLinks);

                        return (
                            <li
                                key={link.path}
                                className="relative"
                                // ✅ Hover buka dropdown, mouse leave nutup lagi
                                onMouseEnter={() => hasSubLinks && setOpenDesktopDropdown(link.path)}
                                onMouseLeave={() => hasSubLinks && setOpenDesktopDropdown(null)}
                            >
                                {hasSubLinks ? (
                                    // ✅ Kalau punya sub-menu, ini BUKAN Link biasa (gak langsung navigasi),
                                    // tapi trigger buat toggle dropdown
                                    <button
                                        type="button"
                                        onClick={() => setOpenDesktopDropdown(openDesktopDropdown === link.path ? null : link.path)}
                                        className={`
                                            flex items-center gap-1 text-base lg:text-lg font-medium relative whitespace-nowrap
                                            transition-colors duration-300 focus:outline-none
                                            ${active ? 'text-blue-600 font-bold' : 'text-gray-600 hover:text-blue-600'}
                                            before:content-[''] before:absolute before:left-0 before:bottom-0 before:h-0.5 before:bg-blue-600 before:transition-all before:duration-300
                                            ${active ? 'before:w-full' : 'hover:before:w-full before:w-0'}
                                        `}
                                    >
                                        {link.name}
                                        <FaChevronDown
                                            className={`text-xs mt-0.5 transition-transform duration-200 ${openDesktopDropdown === link.path ? 'rotate-180' : ''}`}
                                        />
                                    </button>
                                ) : (
                                    <Link
                                        to={link.path}
                                        className={`
                                            text-base lg:text-lg font-medium relative whitespace-nowrap
                                            transition-colors duration-300
                                            ${active ? 'text-blue-600 font-bold' : 'text-gray-600 hover:text-blue-600'}
                                            before:content-[''] before:absolute before:left-0 before:bottom-0 before:h-0.5 before:bg-blue-600 before:transition-all before:duration-300
                                            ${active ? 'before:w-full' : 'hover:before:w-full before:w-0'}
                                        `}
                                    >
                                        {link.name}
                                    </Link>
                                )}

                                {/* ✅ Dropdown Desktop */}
                                {hasSubLinks && (
                                    <div
                                        className={`
            absolute top-full left-1/2 -translate-x-1/2 pt-2 w-64
            transition-all duration-200 origin-top
            ${openDesktopDropdown === link.path
                                                ? 'opacity-100 scale-100 pointer-events-auto'
                                                : 'opacity-0 scale-95 pointer-events-none'
                                            }
        `}
                                    >
                                        {/* ✅ Kotak visual dropdown yang sebenarnya, jaraknya dari padding di parent, bukan margin */}
                                        <div className="bg-white rounded-xl shadow-2xl border border-gray-100">
                                            <ul className="py-2">
                                                {link.subLinks.map((sub) => (
                                                    <li key={sub.path}>
                                                        <Link
                                                            to={sub.path}
                                                            onClick={() => setOpenDesktopDropdown(null)}
                                                            className={`
                                block px-4 py-2.5 text-sm font-medium transition-colors duration-200
                                ${location.pathname === sub.path
                                                                    ? 'bg-blue-50 text-blue-600 font-bold'
                                                                    : 'text-gray-600 hover:bg-gray-50 hover:text-blue-600'
                                                                }
                            `}
                                                        >
                                                            {sub.name}
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                )}
                            </li>
                        );
                    })}
                </ul>

                {/* Menu Mobile */}
                <div
                    className={`
                        lg:hidden absolute top-full left-0 w-full bg-white shadow-xl transition-all duration-300 ease-in-out overflow-hidden
                        ${isMenuOpen ? 'h-auto py-4 opacity-100' : 'h-0 py-0 opacity-0'}
                    `}
                >
                    <ul className="flex flex-col space-y-2 px-4">
                        {navLinks.map((link) => {
                            const active = isLinkActive(link);
                            const hasSubLinks = Boolean(link.subLinks);
                            const isAccordionOpen = openMobileAccordion === link.path;

                            return (
                                <li key={link.path}>
                                    {hasSubLinks ? (
                                        <>
                                            {/* ✅ Trigger accordion, bukan navigasi langsung */}
                                            <button
                                                type="button"
                                                onClick={() => setOpenMobileAccordion(isAccordionOpen ? null : link.path)}
                                                className={`
                                                    w-full flex items-center justify-between text-lg font-medium px-2 py-2 rounded-md
                                                    transition-colors duration-200
                                                    ${active ? 'bg-blue-50 text-blue-600 font-bold' : 'text-gray-700 hover:bg-gray-100'}
                                                `}
                                            >
                                                {link.name}
                                                <FaChevronDown
                                                    className={`text-sm transition-transform duration-200 ${isAccordionOpen ? 'rotate-180' : ''}`}
                                                />
                                            </button>

                                            {/* ✅ Sub-menu mobile (accordion) */}
                                            <div
                                                className={`overflow-hidden transition-all duration-300 ${isAccordionOpen ? 'max-h-96 mt-1' : 'max-h-0'}`}
                                            >
                                                <ul className="flex flex-col space-y-1 pl-4 border-l-2 border-gray-100 ml-2">
                                                    {link.subLinks.map((sub) => (
                                                        <li key={sub.path}>
                                                            <Link
                                                                to={sub.path}
                                                                onClick={() => {
                                                                    setIsMenuOpen(false);
                                                                    setOpenMobileAccordion(null);
                                                                }}
                                                                className={`
                                                                    block text-base font-medium px-2 py-2 rounded-md
                                                                    transition-colors duration-200
                                                                    ${location.pathname === sub.path
                                                                        ? 'bg-blue-50 text-blue-600 font-bold'
                                                                        : 'text-gray-600 hover:bg-gray-100'
                                                                    }
                                                                `}
                                                            >
                                                                {sub.name}
                                                            </Link>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </>
                                    ) : (
                                        <Link
                                            to={link.path}
                                            onClick={() => setIsMenuOpen(false)}
                                            className={`
                                                block text-lg font-medium px-2 py-2 rounded-md
                                                transition-colors duration-200
                                                ${active ? 'bg-blue-50 text-blue-600 font-bold' : 'text-gray-700 hover:bg-gray-100'}
                                            `}
                                        >
                                            {link.name}
                                        </Link>
                                    )}
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </nav>
        </header>
    );
};

export default Header;